import Modal from '@src/common/Modal';
import React from 'react';

const RaisedSoaConfirmPopup = (props: any) => {
    let { show } = props;

    return (
        <React.Fragment>
            <div className="model-outer upload-error-popup">
                <Modal show={show} handleClose={() => props.handleClose()}>
                    <div className="modal-header">
                        <h2 className="modal-title">Raise SOA</h2>
                    </div>
                    <div className="modal-body">
                        <h4>Are you sure to want to raise SOA?</h4><br></br>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-line btn-lg m-sm-r" onClick={() => {
                            props.confirmNo();
                        }}>Cancel</button>
                        <button type="button" className="btn btn-primary btn-raise-confirm" onClick={() => {
                            props.confirmYes();
                        }}>Confirm</button>
                    </div>
                </Modal>
            </div>
        </React.Fragment>
    );
}

export default RaisedSoaConfirmPopup;